export default function ButtonContent({ label, children, icon }) {
  return children || label || icon || null
}
